export const styles = {
   common: {
        height: '100vh',
        display: 'flex',
        justifyContent: 'center'
   }
};